import React, { Component } from 'react';

import CarouselItem from './CarouselItem';

class Carousel extends Component {
  render() {
    return(
      <div>
        <div id="hero_carousel" className="carousel slide carousel-fade" data-ride="carousel">
          <ol className="carousel-indicators">
            <li data-target="#hero_carousel" data-slide-to={0} className="active" />
            <li data-target="#hero_carousel" data-slide-to={1} />
            <li data-target="#hero_carousel" data-slide-to={2} />
          </ol>
          <div className="carousel-inner" role="listbox">
            <CarouselItem active={ true } />
            <CarouselItem />
            <CarouselItem />
          </div>
        </div>
      </div>
    )
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel.js